import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('AttachmentManagement')([
  'SET_LOADER',
  'LOAD_ATTACHMENTS',
  'UPSERT_ATTACHMENT',
  'DELETE_ATTACHMENT',
  'SET_FORM_LOADER',
]);

export function setLoader(flag) {
  return { type: types.SET_LOADER, flag };
}

export function setAttachments(attachments) {
  return { type: types.LOAD_ATTACHMENTS, attachments };
}

export function upsertAttachment(attachment) {
  return { type: types.UPSERT_ATTACHMENT, attachment };
}

export function deleteAttachment(attachment) {
  return { type: types.DELETE_ATTACHMENT, attachment };
}

export function setFormLoader(flag) {
  return { type: types.SET_FORM_LOADER, flag };
}

const initialState = {
  attachments: [],
  isLoading: false,
  isFormLoading: false,
};
export default function attachmentManagementReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isLoading: action.flag };
    }
    case types.LOAD_ATTACHMENTS: {
      return { ...state, attachments: action.attachments };
    }
    case types.UPSERT_ATTACHMENT: {
      return {
        ...state,
        attachments: [...state.attachments.filter((a) => a.id !== action.attachment.id), action.attachment],
      };
    }
    case types.DELETE_ATTACHMENT: {
      return { ...state, attachments: [...state.attachments.filter((a) => a.id !== action.attachment.id)] };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isFormLoading: action.flag };
    }
    default:
      return state;
  }
}

export const getAttachmentByIdSelector = (attachmentId) => (state) =>
  state.attachmentManagementReducer.attachments.find((a) => a.id === attachmentId);

export const getAllAttachmentsSelector = (state) => state.attachmentManagementReducer.attachments;

export const isAttachmentPageLoadingSelector = (state) => state.attachmentManagementReducer.isLoading;

export const isAttachmentFormLodingSelector = (state) => state.attachmentManagementReducer.isFormLoading;
